import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AppProvider } from "@/context/AppContext";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Boutique from "@/pages/Boutique";
import Realisations from "@/pages/Realisations";
import Pathologies from "@/pages/Pathologies";
import Contact from "@/pages/Contact";
import Personnalisation from "@/pages/Personnalisation";
import Temoignages from "@/pages/Temoignages";
import EspaceJeux from "@/pages/EspaceJeux";
import Professionnels from "@/pages/Professionnels";
import EspaceSoignant from "@/pages/EspaceSoignant";
import NosTechniques from "@/pages/NosTechniques";
import Forum from "@/pages/Forum";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import MonCompte from "@/pages/MonCompte";
import Gardiens from "@/pages/Gardiens";
import GardienPage from "@/pages/GardienPage";
import QuizGardiens from "@/pages/QuizGardiens";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/boutique" element={<Boutique />} />
            <Route path="/realisations" element={<Realisations />} />
            <Route path="/pathologies" element={<Pathologies />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/personnalisation" element={<Personnalisation />} />
            <Route path="/mon-compte" element={<MonCompte />} />
            <Route path="/gardiens" element={<Gardiens />} />
            <Route path="/gardiens/:id" element={<GardienPage />} />
            <Route path="/quiz-gardien" element={<QuizGardiens />} />
            <Route path="/temoignages" element={<Temoignages />} />
            <Route path="/espace-jeux" element={<EspaceJeux />} />
            <Route path="/professionnels" element={<Professionnels />} />
            <Route path="/espace-soignant" element={<EspaceSoignant />} />
            <Route path="/nos-techniques" element={<NosTechniques />} />
            <Route path="/forum" element={<Forum />} />
            <Route path="/paiement/succes" element={<PaymentSuccess />} />
            <Route path="/paiement/annule" element={<PaymentCancel />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
